import type { GeometryBuilder } from '../geometry-builder.class';
import type { AddPanelInfo } from '../../../../model/add-panel-info';
import type { GeometryResult } from '../types';
import { loadModelIfNeededCfn } from './load-model.cfn';
import { shouldApplyCsgCfn, applyCsgIntersectionCfn } from './apply-csg.cfn';
import {
	getMaterialCfn,
	createExtrudeGeometryCfn,
	createMeshFromGeometryCfn,
	applyTransformsCfn
} from './create-mesh.cfn';

/**
 * Create a panel from AddPanelInfo
 */
export const createPanelCfn = async (
	self: GeometryBuilder,
	{ api }: { api: AddPanelInfo }
): Promise<GeometryResult> => {
	const { generateFromModel, model } = await loadModelIfNeededCfn(self, { api });

	// Get or create material
	const mat = getMaterialCfn(self, { textureKey: api.textureKey });

	// Create geometry
	const geometry = createExtrudeGeometryCfn(self, { api });

	// Create mesh
	const rawPanel = createMeshFromGeometryCfn(self, { api, geometry, mat });

	// Apply transforms
	applyTransformsCfn(self, { mesh: rawPanel, api });

	// Apply CSG if needed (for slat textures)
	if (shouldApplyCsgCfn(self, { api, generateFromModel, model })) {
		try {
			const csgResult = await applyCsgIntersectionCfn(self, {
				rawPanel,
				model: model!,
				mat,
				api
			});
			return {
				mesh: csgResult,
				panelType: api.panelType,
				id: api.id
			};
		} catch (error) {
			console.error('GeometryBuilder: CSG intersection failed, using raw panel:', error);
		}
	}

	return {
		mesh: rawPanel,
		panelType: api.panelType,
		id: api.id
	};
};
